<template>
  <v-btn icon @click="goBack">
    <v-icon>arrow_back</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: 'BackButton',
  props: ['fallback', 'to'],
  data() {
    return {};
  },
  methods: {
    goBack() {
      if (this.to) {
        this.$router.replace(this.to).catch(() => {});
      } else if (this.$store.state.previousRouteName) {
        this.$router.go(-1);
      } else if (this.fallback) {
        this.$router.push({ name: this.fallback }).catch(() => {});
      } else {
        this.$router.go(-1);
      }
    },
  },
  mounted() {},
};
</script>

<style scoped></style>
